import React, { useState, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import "../styles/Members.css";

function MemberModal(props) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const ImageToggleOnMouseOver = ({ primaryImg, secondaryImg }) => {
    const imageRef = useRef(null);

    return (
      <img
        className="profilePic"
        onMouseOver={() => {
          imageRef.current.src = secondaryImg;
        }}
        onMouseOut={() => {
          imageRef.current.src = primaryImg;
        }}
        src={primaryImg}
        alt=""
        ref={imageRef}
      />
    );
  };

  return (
    <>
      <div className="memberCard" onClick={handleShow}>
        <div className="profilePicDiv">
          <ImageToggleOnMouseOver
            className="profilePic"
            primaryImg={props.pic}
            secondaryImg={props.altPic}
            alt="profile pic"
          />
        </div>

        <div className="nameDiv">
          <p className="memberName" style={props.font}>
            {props.name}
          </p>
        </div>
      </div>

      <Modal show={show} onHide={handleClose} centered size="lg">
        <Modal.Body>
          {/* <div className="popup grid-container row"> */}

          <div className="popup row">
            <div className="popupLeft grid-item ">
              <img className="profilePic" src={props.pic} alt="profile pic" />
            </div>
            <div className="popupRight grid-item ">
              <h4>{props.name}</h4>
              <h5>
                <i>{props.subteam}</i>
              </h5>
              <p>
                <b>Program: </b>
                {props.program}
              </p>
              <p>
                <b>Current Term: </b>
                {props.term}
              </p>
              <p>
                <b>Early bird or night owl? </b>
                {props.bird}
              </p>
              <p>
                <b>What piece of lab equipment are you? </b>
                {props.lab}
              </p>
              <p>
                <b>Where would you like to travel? </b>
                {props.travel}
              </p>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default MemberModal;
